// src/features/feedback/context.ts
import { consoleRingBuffer } from '../../utils/consoleBuffer';
import { currentUiLanguage } from '../../i18n';
import { FEEDBACK_LIMITS, type FeedbackContext } from './types';

function recentConsoleErrors(): string[] {
  return consoleRingBuffer
    .getLastLines(500)
    .filter((line) => line.includes(' [ERROR] '))
    .slice(-FEEDBACK_LIMITS.consoleErrorsMax)
    .map((line) => line.slice(0, FEEDBACK_LIMITS.consoleErrorLength));
}

function resolveTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

export function collectFeedbackContext(workspaceId: string | null): FeedbackContext {
  const { pathname, search, hash, href } = window.location;
  return {
    workspaceId,
    path: `${pathname}${search}${hash}`.slice(0, 2000),
    href: href.slice(0, 4000),
    pageTitle: (document.title || '').slice(0, 500),
    viewport: {
      w: window.innerWidth,
      h: window.innerHeight,
      dpr: window.devicePixelRatio || 1,
    },
    userAgent: navigator.userAgent.slice(0, 1000),
    timezone: resolveTimezone().slice(0, 100),
    uiLanguage: currentUiLanguage(),
    appBuildId: __APP_BUILD_ID__,
    consoleErrors: recentConsoleErrors(),
  };
}
